module.exports = __webpack_public_path__ + "static/media/mouse-wheel.87c4e417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pagIndex/icons/mouse-wheel.svg
// module id = 94
// module chunks = 0